import React, { useState } from "react";
import {injectIntl} from "react-intl";

import Checkbox from "@FormElements/Checkbox";
import Modal from "@Components/Modal";

const CheckboxWithModal = (props) => {
	const [modalOpen, setModalOpen] = useState(false);
	const { intl, settings: { modalTitle, modalHtml } } = props;

	const onShowModal = (e) => {
		e.preventDefault();

		setModalOpen(true);
	};

	const onCloseModal = () => {
		setModalOpen(false);
	};

	return (
		<>
			{modalOpen && modalHtml && (
				<>
					<div className="form-group"/>
					<Modal
						title={intl.formatMessage({id: modalTitle})}
						onClose={onCloseModal}
					>
						<div dangerouslySetInnerHTML={{ __html: intl.formatMessage({id: modalHtml})}} />
					</Modal>
				</>
			)}
			<Checkbox {...props} onClickLinkCb={onShowModal} />
		</>
	);
};

export default injectIntl(CheckboxWithModal);
